
$(document).ready(function(){

    $('.studio_drop_down').click(function(){
      $(this).parents('li').addClass('studio_active_drop_down');
    });

    $('.back_main_menu').click(function(){
      $(this).parents('li').removeClass('studio_active_drop_down');
    });

    function variant_qty() {
        $('.sizevariant_option-1 label input').each(function() {
            var all_size = $(this).val();
            var qty_data = parseInt($('.product_variants option[data-opt1="' + all_size + '"]').attr('data-qty'), 10);
            
            if (qty_data <= 0) {
                $(this).attr('data-disabled', 'true');
                
                // Add "COMING SOON" badge if not already added
                var variantLabel = $(this).parent();
                if (!variantLabel.find('.coming-soon-badge').length) {
                    variantLabel.append('<span class="coming-soon-badge">COMING SOON</span>');
                }
            } else {
                $(this).removeAttr('data-disabled');
                
                // Remove "COMING SOON" badge if stock is available
                $(this).parent().find('.coming-soon-badge').remove();
            }
        });
    }
    
    $('.product_variant_option .product-section__options-values-wrapper label').click(function() {
        setTimeout(variant_qty, 10);
    });
    
    // Initial call to variant_qty to set up initial states
    variant_qty();
    setTimeout(variant_qty, 500);

});